import { render, staticRenderFns } from "./EditConsequenceApproval.vue?vue&type=template&id=78970f7b&scoped=true"
import script from "./EditConsequenceApproval.vue?vue&type=script&lang=js"
export * from "./EditConsequenceApproval.vue?vue&type=script&lang=js"
import style0 from "./EditConsequenceApproval.vue?vue&type=style&index=0&id=78970f7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78970f7b",
  null
  
)

export default component.exports